"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSouthCarolinaRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _Rule = require("../Rule");

var _types = require("../../assets/types");

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'SC';

function getSouthCarolinaRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Local public assistance benefit',
    type: stateCode,
    statuteName: '11 U.S.C. § 522(d)(10)(A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiarytype = _lodash["default"].get(asset, 'assetJSON.tertiarytype');

      return this.canTakeMoreExemptions() && tertiarytype === _tertiaryTypes.LOCAL_PUBLIC_ASSISTANCE_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Health Aids',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(10)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Social Security',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(11)(a)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiarytype = _lodash["default"].get(asset, 'assetJSON.tertiarytype');

      return this.canTakeMoreExemptions() && tertiarytype === _tertiaryTypes.SOCIAL_SECURITY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Veterans\' Benefit',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(11)(b)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VETERANS_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability or Illness Benefits',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(11)(c)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unemployment Compensation',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(11)(c)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNEMPLOYMENT_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony or Maintenance Support',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(11)(d)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.CHILD_SUPPORT || subType === _subTypes.ALIMONY);
    }
  }, {
    id: idCounter.increment(),
    description: 'ERISA (employee retirement account)',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(11)(e); S.C. Code Ann. § 15-41-30 (A)(14)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.ERISA_REITREMENT_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: "Crime Victims' Compensation",
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(12)(a)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Personal Injury Settlement',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(12)(b)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PERSONAL_INJURY_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Wrongful Death Awards',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(12)(b)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WRONGFUL_DEATH_AWARD;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (debtor was dependent)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(12)(c)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'IRA & Roth IRA',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(13)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.ROTH_IRA || subType === _subTypes.IRA);
    }
  }, {
    id: idCounter.increment(),
    description: 'Motor Vehicle (one)',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(2)',
    limitAggregateSingle: 5900,
    limitAggregateJoint: 5900,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      return this.canTakeMoreExemptions() && type === _types.VEHICLE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Household Goods and Furnishings, Books, Antiques, Art, Collectibles, Hobby' + ' Equipment, Clothes, Animals, Crops, Musical Instruments',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(3)',
    limitAggregateSingle: 4725,
    limitAggregateJoint: 4725,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.HOUSEHOLD, _subTypes.BOOK, _subTypes.CLOTHES, _subTypes.PERSONAL_ANIMALS, _subTypes.CROPS, _subTypes.MUSICAL_INSTRUMENT, _subTypes.FARM_ANIMALS, _subTypes.ELECTRONICS];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Jewelry',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(4)',
    limitAggregateSingle: 1175,
    limitAggregateJoint: 1175,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.JEWELRY, _subTypes.WATCH, _subTypes.WEDDING_RINGS];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Cash & Other Liquid Assets - in lieu of burial or homestead. ' + 'Deposits of Money. ' + 'Bonds, mutual funds, or publicly traded stocks. ' + 'Non-publicly traded stock and interests in businesses. ' + 'Government and corporate bonds. ' + 'Security deposits and prepayments. ' + 'Annuities. ' + 'Tax refunds owed to you. ' + 'Unpaid Wages. ' + 'Interests in insurance policies. ' + 'Accounts receivable or commissions you already earned.',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(5)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.CASH, _subTypes.DEPOSIT, _subTypes.BOND, _subTypes.MUTUAL_FUND, _subTypes.STOCK, _subTypes.BOND, _subTypes.CORPORATE_BOND, _subTypes.ANNUITY, _subTypes.TAX_REFUND, _subTypes.UNPAID_WAGES, _subTypes.ACCOUNTS_RECEIVABLE];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Tools of Trade',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(6)',
    limitAggregateSingle: 1775,
    limitAggregateJoint: 1775,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.TOOLS_OF_TRADE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (unmatured)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(8)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNMATURED_TERM_INSURANCE_POLICY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (unmatured, loan)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(9)',
    limitAggregateSingle: 4875,
    limitAggregateJoint: 4875,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNMATURED_TERM_INSURANCE_POLICY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Partnerships',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 33-41-720',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PARTNERSHIP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal benefit',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 38-38-330',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FRATERNAL_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life insurance (beneficiary other than insured\'s estate)',
    type: stateCode,
    requiresReview: true,
    statuteName: 'S.C. Code Ann. § 38-63-40 (A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance Proceeds',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 38-63-40 (B)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PROCEEDS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability and Accident Benefits',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 38-63-40 (D)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS;
    }
  }, // NOTE: FFS
  // {
  //   id: idCounter.increment(),
  //   description: 'Life Insurance after death of insured',
  //   type: stateCode,
  //   statuteName: 'S.C. Code Ann. § 38-63-50',
  //   limitAggregateSingle: Number.MAX_SAFE_INTEGER,
  //   limitAggregateJoint: Number.MAX_SAFE_INTEGER,
  //   limitPerItem: Number.MAX_SAFE_INTEGER,
  //   assetLimit: Number.MAX_SAFE_INTEGER,
  //   canApply(asset: Asset) {
  //     const tertiaryType = _.get(asset, 'assetJSON.tertiaryType');
  //     return this.canTakeMoreExemptions()
  //       && tertiaryType === LIFE_INSURANCE_PROCEEDS;
  //   },
  // },
  {
    id: idCounter.increment(),
    description: 'Life Insurance (group, cash)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 38-65-90',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.GROUP_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life insurance (spouse, child, dependent)',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 38-65-90',
    limitAggregateSingle: 50000,
    limitAggregateJoint: 50000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PAYMENTS_FOR_DEPENDEE;
    }
  }, {
    id: idCounter.increment(),
    description: "Workers' Compensation",
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 42-9-360',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public assistance',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 43-5-190',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PUBLIC_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Blind Aged Disabled Assistance',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 43-5-190',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.AID_TO_BLIND;
    }
  }, {
    id: idCounter.increment(),
    description: 'College Trust Fund',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 59-2-140',
    limitAggregateSingle: 4000,
    limitAggregateJoint: 8000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.TUITION_TRUST, _tertiaryTypes.PREPAID_COLLEGE_TRUST];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'South Carolina Tuition Prepayment Program',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 59-4-40',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.SOUTH_CAROLINA_TUITION_PREPAYMENT_PROGRAM;
    }
  }, {
    id: idCounter.increment(),
    description: 'Police Pensions',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 9-11-270',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.POLICE_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: "Firefighters' Pensions",
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 9-13-230',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.FIREFIGHTERS_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Judges and Solicitors',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 9-8-190',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.JUDGES_PENSIONS;
    }
  }, {
    id: idCounter.increment(),
    description: 'General Assembly Members',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 9-9-180',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.GENERAL_ASSEMBLY_MEMBERS_PENSIONS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public employee pension',
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 9-1-1680',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTypes = [_tertiaryTypes.PUBLIC_EMPLOYEE_PENSION];
      return this.canTakeMoreExemptions() && validTypes.includes(tertiaryType);
    }
  }, {
    id: _Rule.WILDCARD_ID,
    description: 'Wildcard',
    requiresReview: true,
    type: stateCode,
    statuteName: 'S.C. Code Ann. § 15-41-30 (A)(7)',
    limitAggregateSingle: 5900,
    limitAggregateJoint: 5900,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}